import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const ReportsDialogTourConfig: AgTechTourConfig = {
    id: 'reports-dialog-tour',
    name: 'Download Reports Tour',
    steps: [
        {
            targetId: 'reports-dialog-cards',
            title: 'Available Reports',
            description: 'Each card is a report for the current sale. Read the description, then click Download beneath it to save the report.',
            position: 'top',
        },
    ]
}
